window.addEventListener("scroll", function() {
  const nav = document.querySelector(".custom-header");

  if (window.scrollY > 50) {
    nav.classList.add("scrolled");
  } else {
    nav.classList.remove("scrolled");
  }
});
document.querySelector('.blog-btn').addEventListener('click', function(e){
  e.preventDefault();

  document.querySelector('#bl-page-template--22030430044395__blog_listing_tYUk8x').scrollIntoView({
    behavior: 'smooth'
  });
});
